export const staff =[
    {
        id:0,
        thumbnail:"https://media.licdn.com/dms/image/v2/D5635AQGNUp945X9_Xg/profile-framedphoto-shrink_200_200/profile-framedphoto-shrink_200_200/0/1736957510235?e=1739062800&v=beta&t=4VOU1T6N_57rS6DHciFVBuJuaa57PxKwnqfvbCChq2I",
        title:"Myenglishbro",
       subtitle:"Ebook",
       dateAdded:"wswqe",
       calificacion:"Gratis",
       description:"Resumenes de estructuras gramaticales , idioms , phrasal verbs and more ",
       enlaces:"https://drive.googsssssle.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view?usp=sharing",
       precio:0,
       demo:"AAS",
      

    },
    {
        id:0,
        thumbnail:"https://media.licdn.com/dms/image/v2/D5635AQGNUp945X9_Xg/profile-framedphoto-shrink_200_200/profile-framedphoto-shrink_200_200/0/1736957510235?e=1739062800&v=beta&t=4VOU1T6N_57rS6DHciFVBuJuaa57PxKwnqfvbCChq2I",
        title:"biling",
       subtitle:"Ebook",
       dateAdded:"wswqe",
       calificacion:"Gratis",
       description:"Resumenes de estructuras gramaticales , idioms , phrasal verbs and more ",
       enlaces:"https://drive.googsssssle.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view?usp=sharing",
       precio:0,
       demo:"AAS",
      

    }
]